
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";


const LaporanLongwisPenyedia = () => {


  return (
    <Box>
      <Typography>"Under Mainternance"</Typography>
    </Box>
  );
};

export default LaporanLongwisPenyedia;
